// extracted by mini-css-extract-plugin
export default {"main":"vaa-z"};